import Adele21 from "../../../assets/images/albumCovers/adele-21.jpg";
import BeyonceBday from "../../../assets/images/albumCovers/beyonce-bday.jpg";
import BillieEilishHappierThanEver from "../../../assets/images/albumCovers/billie-eilish-happier-than-ever.jpg";
import DionneWarwickMakeWayForDionneWarwick from "../../../assets/images/albumCovers/dionne-warwick-make-way-for-dionne-warwick.jpg";
import DrakeTakeCare from "../../../assets/images/albumCovers/drake-take-care.jpg";
import FrankOceanBlond from "../../../assets/images/albumCovers/frank-ocean-blond.jpg";
import GorillazDemonDays from "../../../assets/images/albumCovers/gorillaz-demon-days.jpg";
import JanelleMonaeDirtyComputer from "../../../assets/images/albumCovers/janelle-monae-dirty-computer.jpg";
import KanyeWestGraduation from "../../../assets/images/albumCovers/kanye-west-graduation.jpg";
import KendrickLamarDamn from "../../../assets/images/albumCovers/kendrick-lamar-damn.jpg";
import LanaDelReyBornToDie from "../../../assets/images/albumCovers/lana-del-rey-born-to-die.jpg";
import MichaelJacksonThriller from "../../../assets/images/albumCovers/michael-jackson-thriller.jpg";
import ShakiraShakira from "../../../assets/images/albumCovers/shakira-shakira.jpg";
import TaylorSwift1989 from "../../../assets/images/albumCovers/taylor-swift-1989.jpg";
import TheBeatlesAbbeyRoad from "../../../assets/images/albumCovers/the-beatles-abbey-road.jpg";
import TheWeekndBeautyBehindTheMadness from "../../../assets/images/albumCovers/the-weeknd-beauty-behind-the-madness.jpg";

const slides = [
    {
      name: "Lana Del Rey's Born to Die Album Cover",
      imagePath: LanaDelReyBornToDie,
    },
    {
      name: "Kanye West's Graduation Album Cover",
      imagePath: KanyeWestGraduation,
    },
    {
      name: "Kendrick Lamar's DAMN Album Cover",
      imagePath: KendrickLamarDamn,
    },
    {
      name: "Drake's Take Care Album Cover",
      imagePath: DrakeTakeCare,
    },
    {
      name: "Janelle Monae's Dirty Computer Album Cover",
      imagePath: JanelleMonaeDirtyComputer,
    },
    {
      name: "Beyoncé's B'Day Album Cover",
      imagePath: BeyonceBday,
    },
    {
      name: "The Weeknd's Beauty Behind the Madness Album Cover",
      imagePath: TheWeekndBeautyBehindTheMadness,
    },
    {
      name: "Shakira's Shakira Album Cover",
      imagePath: ShakiraShakira,
    },
    {
      name: "Frank Ocean's Blond Album Cover",
      imagePath: FrankOceanBlond,
    },
    {
      name: "Michael Jackson's Thriller Album Cover",
      imagePath: MichaelJacksonThriller,
    },
    {
      name: "The Beatles' Abbey Road Album Cover",
      imagePath: TheBeatlesAbbeyRoad,
    },
    {
      name: "Dionne Warwick's make way for dionne warwick album cover",
      imagePath: DionneWarwickMakeWayForDionneWarwick,
    },
    {
      name: "Gorillaz's Demon Days Album Cover",
      imagePath: GorillazDemonDays,
    },
    {
      name: "Taylor Swift's 1989 Album Cover",
      imagePath: TaylorSwift1989,
    },
    {
      name: "Adele's 21 Album Cover",
      imagePath: Adele21,
    },
    {
      name: "Billie Eilish's Happier Than Ever Album Cover",
      imagePath: BillieEilishHappierThanEver,
    },
  ];

  export default slides